import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import PopoutApp from './PopoutApp.tsx'
import { ErrorBoundary } from './components/ErrorBoundary'
import { readPopoutSheetId, setupWindowSync } from './windowSync'

// Set up cross-window state sync — must happen BEFORE any component reads
// from the store, so the BroadcastChannel listener is in place to catch the
// main window's snapshot when this is a popout.
setupWindowSync();

const popoutSheetId = readPopoutSheetId();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {popoutSheetId ? (
      <PopoutApp sheetId={popoutSheetId} />
    ) : (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )}
  </StrictMode>,
)
